import React from 'react';
import cn from 'classnames';
import { Icon } from '@economic/taco';

interface Props {
    stepsCount: number;
    currentStep: number;
    withCompleteTicks?: boolean;
    className?: string;
}

export function ProgressDots({ stepsCount, currentStep, withCompleteTicks = true, className }: Props) {
    const zeroStartingStepsRange = [...Array(stepsCount).keys()];
    const currentStepIndex = currentStep - 1;

    return (
        <div className={cn('progress-dots justify-center flex space-x-6', className)}>
            {zeroStartingStepsRange.map(i => (
                <span
                    key={i}
                    className={cn('flex justify-center items-center h-4 w-4 rounded-full', {
                        'bg-blue text-white': i <= currentStepIndex,
                        'border border-grey-dark': i > currentStepIndex,
                    })}>
                    {withCompleteTicks && i < currentStepIndex && <Icon name="tick" />}
                </span>
            ))}
        </div>
    );
}
